export function nameof(args: object = {}): string {
	return Object.keys(args)[0] || 'none';
}
